export * from './app-sidebar.component';



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar/index.ts